<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.br_tbl_td_bottom {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.br_tbl_td_no_borders {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
}

tr:hover {
    background-color: transparent !important;
}

.br_rd_odd {
    background-color: rgba(0, 0, 0, .03) !important;
}

.rc_section {
    padding-top: 12px;
}

.br_label {
    color: rgba(0, 0, 0, 0.6);
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    padding-bottom: 16px;
}

.br_section {
    padding-bottom: 16px;
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.v-label {
    font-size: 20px;
}

.msg_ok {
    color: rgba(0, 200, 0);
}

.msg_err {
    color: rgba(255, 0, 0);
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
    <div>
        <div class="br_section"><h2 class="br">BisonRouter GUI</h2></div>
        <p>
            Version: a0.25.0
        </p>
    </div>
</template>

<script>

export default {
    name: 'about',
    components: { 
    },

    data: () => ({
    }),

    created() {
    },

    methods: {
    }
};
</script>
